import hydrate from '../common/hydrate';
import OfferTeaser from './components/OfferTeaser';
import { root, name } from './manifest.json';
hydrate(OfferTeaser, root, name);
if (module.hot) {
    module.hot.accept();
}
